const API_URL = process.env.REACT_APP_API_URL || '';
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || '';

export function isPushSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export function getPushPermission() {
  if (typeof Notification === 'undefined') return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) output[i] = raw.charCodeAt(i);
  return output;
}

export async function registerServiceWorker() {
  if (!isPushSupported()) return null;
  try {
    return await navigator.serviceWorker.register('/sw.js');
  } catch (e) {
    console.error('Service worker registration failed:', e);
    return null;
  }
}

// Requests permission, subscribes to push, and posts the subscription to the
// server. Returns the resulting Notification permission string.
export async function subscribeToPush() {
  if (typeof Notification === 'undefined' || !('serviceWorker' in navigator)) {
    throw new Error('This browser doesn\u2019t support notifications.');
  }
  if (!('PushManager' in window)) {
    throw new Error('On iPhone/iPad, add this app to your Home Screen (Share \u2192 Add to Home Screen), open it from there, then try again.');
  }
  if (!VAPID_PUBLIC_KEY) {
    throw new Error('Reminders aren\u2019t set up yet \u2014 the site is missing its notification key (VAPID).');
  }

  const permission = await Notification.requestPermission();
  if (permission === 'denied') {
    throw new Error('Notifications are blocked for this site. Allow them in Settings, then try again.');
  }
  if (permission !== 'granted') return permission;

  const registration =
    (await navigator.serviceWorker.getRegistration()) || (await registerServiceWorker());
  if (!registration) throw new Error('Service worker unavailable');
  await navigator.serviceWorker.ready;

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
  }

  await fetch(`${API_URL}/api/push/subscribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(subscription),
    credentials: 'include',
  });

  return permission;
}
